import { MappingType } from 'apis/merchant-gateway/integrations-middleware-service/types';

export type FormData = {
  sshKey: string;
};

export type MappingFormData = {
  config: string;
};

export type MappingOption = {
  key: string;
  type: MappingType;
};

export type ValidationContext = {
  type: MappingType;
};

export const ALL_MAPPING_TYPES: MappingOption[] = [
  {
    key: 'Inventory Update - CSV',
    type: MappingType.INVENTORY_UPDATE_CSV,
  },
  {
    key: 'Inventory Update - JSON',
    type: MappingType.INVENTORY_UPDATE_JSON,
  },
  {
    key: 'Item Update - CSV',
    type: MappingType.ITEM_UPDATE_CSV,
  },
  {
    key: 'Item Update - JSON',
    type: MappingType.ITEM_UPDATE_JSON,
  },
];
